import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'pages',
  children: {
    folder: {
      path: ':folderSlug',
      children: {
        page: {
          path: ':pageId',
        },
      },
    },
  },
} as const satisfies Location
